<script setup lang="ts">
  import { useAppRouting } from '@/composables/useAppRouting'
  import RouteParam from '@/enums/RouteParam'

  import VgsContentBlock from '@/components/VgsContentBlock.vue'
  import Layout from '@/components/layout/Layout.vue'
  import FocusHeader from '@/components/layout/FocusHeader.vue'

  const { getContentIdFromRouteParam } = useAppRouting()
  const contentId = getContentIdFromRouteParam(RouteParam.SubjectContent)
</script>

<template>
  <Layout :is-footer-hidden="true">
    <template #header>
      <FocusHeader />
    </template>
    <VgsContentBlock
      v-if="contentId"
      :content-id="contentId"
    />
    <div id="audio-embed-outlet" />
  </Layout>
</template>

<style lang="scss" scoped>
  #audio-embed-outlet {
    position: fixed;
    bottom: 0;
    width: 100%;
  }
</style>
